import { Component, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, LoadingController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Util } from '../../app/util';

/**
 * Generated class for the SelectSquadraPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-select-squadra',
  templateUrl: 'select-squadra.html',
})
export class SelectSquadraPage extends Util {
  myInput;
  shouldShowCancel = true;
  squadre=[];
  squadreaux=[];
  constructor(public navCtrl: NavController, public navParams: NavParams,injector: Injector, loading: LoadingController,public translate: TranslateService,public navParam: NavParams, public viewcontroller:ViewController ) {
    super(injector, loading);
    this.squadre = this.navParam.get('squadre');
    this.squadreaux = this.navParam.get('squadre');
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad SelectSquadraPage');

    
  }
  
  getItems(ev: any) {
    // Reset items back to all of the items
    // this.initializeItems();
    this.squadre = this.squadreaux;
    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.squadre = this.squadre.filter((item) => {
        return (item.nome.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
  onCancel($event){

  }
  iscriviti(s){
    const alert = this.alertCtrl.create({
      title: 'Selezione direzione',
      subTitle: 'Hai selezionato la direzione "'+s.nome+'", confermi questa scelta?',
      cssClass: 'alertdirezione',
      buttons: [{
        text: 'Annulla',
        handler: data => {
          // console.log('Cancel clicked');
        }
      },
      {
        text: 'SI CONFERMO',
        handler: data => {
          // console.log('Saved clicked');
          this.viewcontroller.dismiss(s);
        }
      }]
    });
    alert.present();

   
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-squadra/select-squadra.ts